import { cn } from '@latitude/token-utils';

import type { SVGProps } from '../../types';

export const TriPartyIllustration = (props: SVGProps) => {
  const { title = 'TriPartyIllustration', className, ...restProps } = props;

  return (
    <svg
      className={cn('text-color-ref-primary-primary-50', className)}
      viewBox="0 0 138 96"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
      fill="none"
    >
      <title>{title}</title>
      <path
        d="M106.287 53.744L99.8117 76.3997L67.4894 83.9603C67.4894 83.9603 56.2269 87.7799 54.1471 77.4331C54.0948 78.0479 52.3681 78.6234 52.3681 78.6234C52.3681 78.6234 47.2013 80.2324 41.2103 71.8607C39.3136 71.2721 36.0435 69.8332 33.7151 65.9614C35.8734 64.6795 36.7368 64.9411 36.7368 64.9411C36.7368 64.9411 29.6863 65.739 25.8406 58.61C31.099 56.8049 67.4632 44.4044 67.4632 44.4044L76.2273 58.0214C76.2273 58.0214 78.8957 64.8233 87.8036 60.6244L81.9566 41.095L82.8722 41.1735L106.274 53.7309L106.287 53.744Z"
        fill="white"
        stroke="white"
        strokeWidth="0.732517"
        strokeMiterlimit="10"
      />
      <path
        d="M25.71 40.7074L38.5944 53.8796"
        stroke="white"
        strokeWidth="1.2165"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M65.292 41.0185L76.8422 58.9651C80.1385 64.5244 87.83 60.6395 87.83 60.6395L81.8783 40.7438C74.4877 28.3172 59.772 29.1413 59.772 29.1413L54.1211 29.4029L45.1609 21.2798"
        fill="black"
      />
      <path
        d="M65.292 41.0185L76.8422 58.9651C80.1386 64.5244 87.83 60.6395 87.83 60.6395L81.8783 40.7438C74.4877 28.3172 59.772 29.1413 59.772 29.1413L54.1211 29.4029L45.1609 21.2798"
        stroke="black"
        strokeWidth="0.732517"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M98.6082 76.3087L63.5128 84.9419C63.5128 84.9419 55.8737 85.9229 54.0947 78.0353"
        fill="white"
      />
      <path
        d="M98.6082 76.3087L63.5128 84.9419C63.5128 84.9419 55.8737 85.9229 54.0947 78.0353"
        stroke="white"
        strokeWidth="0.732517"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M87.6209 58.6774C87.6209 58.6774 83.1604 60.064 80.0864 52.9481L85.4103 51.4046"
        stroke="currentColor"
        strokeWidth="1.2165"
        strokeMiterlimit="10"
      />
      <path
        d="M33.1921 65.6205L60.897 56.8303"
        stroke="black"
        strokeWidth="1.56968"
        strokeMiterlimit="10"
      />
      <path
        d="M38.9868 72.9059L64.5987 65.0837"
        stroke="black"
        strokeWidth="1.56968"
        strokeMiterlimit="10"
      />
      <path
        d="M49.1633 80.3385L66.7568 74.086"
        stroke="black"
        strokeWidth="1.56968"
        strokeMiterlimit="10"
      />
      <path
        d="M82.8855 41.1854C75.495 28.7588 59.7459 29.125 59.7459 29.125L54.095 29.3866L45.1348 21.2635"
        stroke="white"
        strokeWidth="1.2165"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M64.7427 41.0179L75.7566 59.1608"
        stroke="white"
        strokeWidth="1.2165"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M97.1484 83.0963L106.745 85.8373C106.995 85.9087 107.256 85.7639 107.327 85.5138L117.469 50.007C117.54 49.7569 117.395 49.4963 117.145 49.4249L107.548 46.6839C107.298 46.6125 107.038 46.7573 106.966 47.0074L96.8249 82.5142C96.7535 82.7643 96.8983 83.0249 97.1484 83.0963Z"
        fill="black"
      />
      <path
        d="M117.628 49.5047L107.346 85.5027C107.281 85.7512 107.019 85.8951 106.771 85.8166L96.7119 82.6249"
        stroke="currentColor"
        strokeWidth="1.30807"
        strokeMiterlimit="10"
      />
      <path
        d="M103.945 55.2515L106.574 46.1473C106.627 45.9511 106.836 45.8334 107.032 45.8857L113.075 47.6647"
        stroke="white"
        strokeWidth="1.2165"
        strokeMiterlimit="10"
      />
      <path
        d="M16.408 38.1626L25.2805 45.2683C25.4948 45.4399 25.8076 45.4053 25.9792 45.191L49.0296 16.4091C49.2012 16.1948 49.1666 15.882 48.9523 15.7104L40.0799 8.60477C39.8656 8.43316 39.5528 8.46775 39.3812 8.68202L16.3308 37.4639C16.1592 37.6782 16.1937 37.991 16.408 38.1626Z"
        fill="currentColor"
      />
      <path
        d="M136.843 52.6889L95.9007 58.2351L88.6147 4.4344L121.29 6.10352e-05L126.209 3.54492L130.617 6.72352L136.843 52.6889Z"
        fill="currentColor"
      />
      <path
        d="M130.617 6.72346L122.35 7.83531L121.29 0L130.617 6.72346Z"
        fill="white"
      />
      <path
        d="M97.4573 25.5984L126.653 21.648"
        stroke="white"
        strokeWidth="1.30807"
        strokeMiterlimit="10"
      />
      <path
        d="M98.0063 29.6671L127.215 25.7037"
        stroke="white"
        strokeWidth="1.30807"
        strokeMiterlimit="10"
      />
      <path
        d="M98.5562 33.7349L127.765 29.7714"
        stroke="white"
        strokeWidth="1.30807"
        strokeMiterlimit="10"
      />
      <path
        d="M99.1182 37.8023L117.379 35.317"
        stroke="white"
        strokeWidth="1.30807"
        strokeMiterlimit="10"
      />
      <path
        d="M100.544 48.3719L108.275 47.3254"
        stroke="white"
        strokeWidth="1.30807"
        strokeMiterlimit="10"
      />
      <path
        d="M117.837 11.2501L109.805 7.7052L103.226 13.513L111.257 17.0579L117.837 11.2501Z"
        fill="black"
      />
      <path
        d="M122.35 7.83695L131.048 9.9037L130.617 6.7251L122.35 7.83695Z"
        fill="black"
      />
      <path
        d="M95.9004 58.2344L103.553 60.2881L104.416 57.0833L95.9004 58.2344Z"
        fill="black"
      />
      <path
        d="M14.6956 53.8795H7.38354V61.1916H14.6956V53.8795Z"
        stroke="currentColor"
        strokeWidth="1.30807"
        strokeMiterlimit="10"
      />
      <path
        d="M9.05786 57.2151L11.033 59.1249L17.4818 53.8796"
        stroke="white"
        strokeWidth="1.30807"
        strokeMiterlimit="10"
      />
      <path
        d="M14.6956 67.3241H7.38354V74.6362H14.6956V67.3241Z"
        stroke="currentColor"
        strokeWidth="1.30807"
        strokeMiterlimit="10"
      />
      <path
        d="M9.05786 70.6466L11.033 72.5695L17.4818 67.3242"
        stroke="white"
        strokeWidth="1.30807"
        strokeMiterlimit="10"
      />
      <path
        d="M26.7172 15.6574V11.7202L19.1958 15.6574H0.333496V30.0854H29.0455V15.7359L26.7172 15.6574Z"
        fill="white"
        stroke="white"
        strokeWidth="0.667113"
        strokeMiterlimit="10"
      />
      <path
        d="M8.07776 24.6848C9.04581 24.6848 9.83057 23.9001 9.83057 22.932C9.83057 21.964 9.04581 21.1792 8.07776 21.1792C7.10971 21.1792 6.32495 21.964 6.32495 22.932C6.32495 23.9001 7.10971 24.6848 8.07776 24.6848Z"
        fill="currentColor"
      />
      <path
        d="M14.9579 24.6848C15.9259 24.6848 16.7107 23.9001 16.7107 22.932C16.7107 21.964 15.9259 21.1792 14.9579 21.1792C13.9898 21.1792 13.2051 21.964 13.2051 22.932C13.2051 23.9001 13.9898 24.6848 14.9579 24.6848Z"
        fill="currentColor"
      />
      <path
        d="M21.8253 24.6848C22.7934 24.6848 23.5781 23.9001 23.5781 22.932C23.5781 21.964 22.7934 21.1792 21.8253 21.1792C20.8573 21.1792 20.0725 21.964 20.0725 22.932C20.0725 23.9001 20.8573 24.6848 21.8253 24.6848Z"
        fill="currentColor"
      />
      <path
        d="M101.329 57.5017L136.843 52.688L134.279 33.7341"
        stroke="white"
        strokeWidth="1.30807"
        strokeMiterlimit="10"
      />
      <path
        d="M102.467 64.882L98.6348 78.3027"
        stroke="currentColor"
        strokeWidth="1.30807"
        strokeMiterlimit="10"
      />
      <path
        d="M38.5818 85.1439C35.05 85.1439 32.5647 82.2923 32.5647 78.7605C32.5647 82.2923 29.7 85.1569 26.1682 85.1569C29.7 85.1569 32.5647 88.0216 32.5647 91.5534C32.5647 88.0216 35.05 85.1439 38.5818 85.1439Z"
        fill="currentColor"
      />
      <path
        d="M38.5818 85.1439C35.05 85.1439 32.5647 82.2923 32.5647 78.7605C32.5647 82.2923 29.7 85.1569 26.1682 85.1569C29.7 85.1569 32.5647 88.0216 32.5647 91.5534C32.5647 88.0216 35.05 85.1439 38.5818 85.1439Z"
        stroke="currentColor"
        strokeWidth="1.30807"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M44.0751 93.2269C42.5577 93.2269 41.7206 92.0235 41.7206 90.5061C41.7206 92.0235 40.491 93.253 38.9736 93.253C40.491 93.253 41.7206 94.4826 41.7206 96C41.7206 94.4826 42.9502 93.253 44.4675 93.253L44.0751 93.2269Z"
        fill="currentColor"
      />
      <path
        d="M44.0751 93.2269C42.5577 93.2269 41.7206 92.0235 41.7206 90.5061C41.7206 92.0235 40.491 93.253 38.9736 93.253C40.491 93.253 41.7206 94.4826 41.7206 96C41.7206 94.4826 42.9502 93.253 44.4675 93.253L44.0751 93.2269Z"
        stroke="currentColor"
        strokeWidth="1.30807"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};
